import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {PiecesComponent} from '../pieces/pieces.component';
import {EstimationRapideComponent} from '../estimation-rapide/estimation-rapide.component';
import {BatimentComponent} from '../batiment/batiment.component';
import {PartenairesComponent} from '../partenaires/partenaires.component';
import {cloneDeep} from "lodash";
import {specialCompaniesButtonPartners, specialCompaniesParcours, specialPathForNewRefs} from "../const/utils";
import {CookieHelper} from '../helpers/cookie.helper';
import {ROUTES_PATHS} from "../const/routes";
import {specialRenovationTypesNrj} from "../const/utils";
import {SiteKeyEnum} from "../enums/site-key.enum";
import {isSpecialPathForNewRefs} from "../helpers/user-ref.helper";
import {CodePermissionEnum} from "../enums/code-permission.enum";

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./footer.component.less']
})
export class FooterComponent implements OnInit {
	_isSpecialPathForNewRefs: boolean = false;
	textes: any;
	nameJson: any;
	modalsTxt: any;
	isTrial: any;
	canGoBackRoom: boolean = true;
	_page: any = location.pathname.split('/')[1];
	outOfSimu: boolean = false;
	renovation: string = localStorage.getItem("RENOVATION")!;
	token = JSON.parse(localStorage.getItem("token")!);

	constructor(
		public app: AppComponent,
		private batiment: BatimentComponent,
		private pieces: PiecesComponent,
		private estRapide: EstimationRapideComponent,
		private partenaires: PartenairesComponent,
		private cookieHelper: CookieHelper,
	) {
	}

	ngOnInit(): void {
		console.log("_page", this._page);

		this._isSpecialPathForNewRefs = isSpecialPathForNewRefs(this.app.sharedToolsService);

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
		this.app.dataToolsService.currentIsTrial.subscribe(resp => {
			this.isTrial = resp;
			console.log('update this.isTrial => ', this.isTrial);
		});
		this.app.sharedToolsService.getParamSettings('use_permissions').subscribe((isUsed: boolean) => {
			if(isUsed){
				this.canGoBackRoom = this.app.sharedToolsService.hasPermission(CodePermissionEnum.QuickSimulation_BackToRooms);
			} else{
				this.canGoBackRoom = true;
			}
		});
	}

	getInfosInit(_nameJson: any) {
		// Get the texts
		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;

				// Get the modal texts
				this.app.dataInitService.getModalTextsOnce(modalsTxt => {
					this.modalsTxt = modalsTxt;
				});

				if (this._page == ROUTES_PATHS.WELCOME) {
					console.log('getInfosInit _page ==> ', this._page);

					this.token = JSON.parse(localStorage.getItem("token")!);
					this.outOfSimu = (this.token && this.token?.outOfSimu) ? this.token.outOfSimu : false;

					console.log('getInfosInit outOfSimu ==> ', this.outOfSimu);
				}

				// if (this._page == ROUTES_PATHS.PRODUITS){
				// 	console.log(this.textes)
				// }
			})
	}

	showButtonBackToWelcome(_pathBtnPrecedent: string) {
		let byPassWelcome = this.cookieHelper.getCookie(this.cookieHelper.cookieByPassWelcomeName) === 'true';
		if (_pathBtnPrecedent === ROUTES_PATHS.WELCOME && byPassWelcome) return false;
		else return true;
	}

	public get footerJustifyClass(): string {
		// priorité au special path
		if (this._isSpecialPathForNewRefs && this._page == ROUTES_PATHS.PIECES) {
			return 'justify-content-end';
		}

		// si textes peut être null/undefined, utilisez l'opérateur safe
		return (this.textes && this.textes.labelBtnPrecedent) ? 'justify-content-between' : 'justify-content-end';
	}

	public showBackButtonFct(_path: any) {
		// console.log("showBackButtonFct _path ==> ", _path);


		if (_path == ROUTES_PATHS.ESTIMATION_RAPIDE) //_path == ROUTES_PATHS.PARTENAIRES ||
			return specialCompaniesParcours.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) == -1 && this.canGoBackRoom;
		else if(_path == ROUTES_PATHS.PIECES)
			return specialPathForNewRefs.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) == -1;
		else
			return true;
	}

	public showSetupButtonFct(_path: any) {
		return true;
		/*if (_path == ROUTES_PATHS.ESTIMATION_RAPIDE)
			return specialCompaniesParcours.indexOf(this.app.sharedToolsService.returnObjectSwitchRefId()) == -1;
		else
			return true;*/
	}

	public onSubmitFct(_path: any) {
		if (_path == ROUTES_PATHS.BATIMENT) this.batiment.onSubmit();
		else if (_path == ROUTES_PATHS.PIECES) this.pieces.onSubmit();
		else if (_path == ROUTES_PATHS.ESTIMATION_RAPIDE) this.estRapide.onSubmit();
		else if (_path == ROUTES_PATHS.PARTENAIRES) this.partenaires.onSubmit();
		else return;
	}

	onClickPrecedent(_path: string) {
		// Si on doit aller sur la page batiment, on affiche une confirmation avant de revenir à la page précédente
		if (_path === ROUTES_PATHS.BATIMENT) {
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalRetourBatiment, "confirm", "", () => {
				//this.app.sharedToolsService.goTo(this.textes.pathBtnPrecedent, null);
				this.app.sharedToolsService.goTo(_path, null)
			}, () => {
				return;
			});
		} else {
			// Si on est sur la page partenaires, on vérifie si le partenaire est dans la liste des partenaires spéciaux et on redirige vers la page d'accueil
			// Sinon on redirige vers la page précédente (pathBtnPrecedent)
			let currentPath = window.location.pathname;
			if (currentPath.includes(ROUTES_PATHS.PARTENAIRES)) {
				if (specialCompaniesButtonPartners.includes(this.app.sharedToolsService.returnObjectSwitchRefId()) || this.isTrial) {
					setTimeout(() => {
						history.back();
					}, 100);

					return;
				}
				this.app.sharedToolsService.goTo(_path, null);
			} else if (currentPath.includes(ROUTES_PATHS.PRODUITS)) {
				if (this.app.sharedToolsService.returnObjectSwitchRefId() == SiteKeyEnum.KOUTRAVOFREE) {
					setTimeout(() => {
						history.back();
					}, 100);

					return;
				}
				this.app.sharedToolsService.goTo(_path, null);
			} else {
				//this.app.sharedToolsService.goTo(this.textes.pathBtnPrecedent, null);
				this.app.sharedToolsService.goTo(_path, null);
			}
		}
	}

	//_arrPrestations: any
	onClickReglages() {
		this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
			let prestations = cloneDeep(opts.tabsPrestations);
			if (prestations.length > 0) prestations = prestations.filter((presta: any) => {
				return presta.id != 99
			});

			let modal: any = {
				name: "modal-reglages",
				//data: _arrPrestations
				data: prestations,
			}

			localStorage.setItem('modalOpen', JSON.stringify(modal));
			//Open modal
			this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
				console.log("Yes clicked");
			}, () => {
				localStorage.removeItem("modalOpen");
				console.log("No clicked");
			})
		});
	}

	onClickChoixScenario() {
		this.getParamsEnergetiques();
	}

	getParamsEnergetiques() {
		let batiment: any = JSON.parse(localStorage.getItem("BATIMENT")!);
		let batSimId: any = (batiment) ? batiment.simulationId : null;
		let simId = +batSimId;

		this.app.apiToolsService.getParamsEnergetiques(simId).subscribe((res: any) => {
			console.log('getParamsEnergetiques res => ', res);
			let scenarios: any;
			if (res == null || !res.length) {
				this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
					scenarios = cloneDeep(opts.scenarios);
					this.openScenarioModal(scenarios);
				});
			} else {
				scenarios = res;
				this.openScenarioModal(scenarios);
			}
		});
	}

	openScenarioModal(scenarios: any) {
		let modal: any = {
			name: "modal-scenario-nrj",
			data: scenarios,
		};

		localStorage.setItem('modalOpen', JSON.stringify(modal));
		this.app.confirmDialogService.confirmThis("", "", "modalCustom", modal.name, () => {
			console.log("Yes clicked");
		}, () => {
			localStorage.removeItem("modalOpen");
			console.log("No clicked");
		});
	}

	public readonly ROUTES_PATHS = ROUTES_PATHS;
	public readonly specialRenovationTypesNrj = specialRenovationTypesNrj;
}
